import { render, staticRenderFns } from "./BagFooter.vue?vue&type=template&id=0d7e4054"
import script from "./BagFooter.vue?vue&type=script&lang=js"
export * from "./BagFooter.vue?vue&type=script&lang=js"
import style0 from "./BagFooter.vue?vue&type=style&index=0&id=0d7e4054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports